var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRenameSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3342 4.60156L13.8217 6.11406L17.8842 10.1766L19.3967 8.66406C20.1779 7.88281 20.1779 6.61719 19.3967 5.83594L18.1654 4.60156C17.3842 3.82031 16.1185 3.82031 15.3373 4.60156H15.3342ZM13.1154 6.82031L5.83103 14.1078C5.50603 14.4328 5.26853 14.8359 5.13728 15.2766L4.03103 19.0359C3.95291 19.3016 4.02478 19.5859 4.21853 19.7797C4.41228 19.9734 4.69666 20.0453 4.95916 19.9703L8.71853 18.8641C9.15916 18.7328 9.56228 18.4953 9.88728 18.1703L17.1779 10.8828L13.1154 6.82031Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameSolid);
export default __webpack_public_path__ + "static/media/rename-solid.4f99db956e86019ed5ddf5ade49930ca.svg";
export { ForwardRef as ReactComponent };